import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../ScrollToTop';
import ErrorBoundary from '../ErrorBoundary';
import Advertisement from '../Advertisement';

const MainLayout = ({ children, showPageTopAd = false }) => {

  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col bg-slate-50">
        <Header />
        {showPageTopAd && (
          <div className="w-full flex justify-center my-4 md:my-6">
            <Advertisement adId="seattle-ad-10001" />
          </div>
        )}
        <main className="flex-grow w-full">
          {children}
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </ErrorBoundary>
  );
};

export default MainLayout; 